import { ReactComponent as InfoIcon } from '@/assets/info.svg'
import { Banner, PrimaryButton, SecondaryButton, StepperFormProps } from '@/components'
import { config } from '@/config'
import { useFormContext } from '@/providers'
import { paths } from '@/routes/paths'
import { useSuggestableStationList } from '@/services'
import { AnyObject } from 'yup'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import type { SuggestPatientState } from '../SuggestPatientPage/Page'
import { OnboardingValues } from './Page'

const useMessages = () => {
  const { t } = useTranslation()

  return {
    texts: t('onboardingPage.failedSearchModal', { returnObjects: true }),
  }
}

export const OnboardingFailedSearch: StepperFormProps<AnyObject, string>['errorComponent'] = ({
  onReset,
}) => {
  const messages = useMessages()
  const navigate = useNavigate()
  const { values } = useFormContext<Partial<OnboardingValues>>()

  // Nur Stationen mit Opt-in nehmen Vorschlaege an - ohne solche Station bleibt es beim
  // Hinweis, sich an die Station zu wenden.
  const { data: suggestableStations = [] } = useSuggestableStationList(values.hospital || '')
  const suggestionAllowed = values.station
    ? suggestableStations.some((station) => station.id === Number(values.station))
    : suggestableStations.length > 0

  const goToSuggestion = () => {
    const state: SuggestPatientState = {
      hospital: values.hospital,
      station: values.station,
      date_of_birth: values.date_of_birth,
      patient_first_name: values.patient_first_name,
      patient_last_name: values.patient_last_name,
    }
    navigate(`/${paths.suggestPatient}`, { state })
  }

  return (
    <>
      <span className="text-h2reg text-center">{messages.texts.title}</span>
      <div className="flex flex-col gap-4 w-full">
        <Banner
          title={messages.texts.reasonTitle}
          icon={<InfoIcon fill="var(--primary)" height={24} width={24} className="shrink-0" />}
        >
          {messages.texts.reasonText}
        </Banner>
        <div className="flex flex-col gap-1">
          <span className="text-h4">{messages.texts.todoTitle}</span>
          <span className="text-b90 text-textS">{messages.texts.todoText}</span>
        </div>
        <span className="text-b90 text-textS">{messages.texts.checkText}</span>
      </div>
      <div className="flex flex-col gap-4 w-full">
        <PrimaryButton onClick={onReset} type="reset" block>
          {messages.texts.button}
        </PrimaryButton>
        {suggestionAllowed && (
          <>
            <SecondaryButton onClick={goToSuggestion} type="button" block>
              {messages.texts.suggestButton}
            </SecondaryButton>
            <span className="text-b90 text-textS text-center">{messages.texts.suggestText}</span>
          </>
        )}
      </div>
      <div className="text-center text-textS text-b90">
        <Trans
          i18nKey={'onboardingPage.failedSearchModal.hint'}
          values={{
            mail: config.supportEmail,
            phone: config.contactPhone,
          }}
          components={[
            <a className="underline" href={`mailto:${config.supportEmail}`} />,
            <a className="underline" href={`tel:${config.contactPhone}`} />,
          ]}
        />
      </div>
    </>
  )
}
